const app = {
  name: 'RBS',
  fullname: 'RBS Monitoring',
  company: 'PT. Teknologi Readymix Indonesia',
  guide: '',
  site: '',
  code: 'rbs-rbs',
  logo: {
    sm: './static/img/logo/logo-brand.png',
    md: './static/img/logo/logo-brand.png',
    lg: './static/img/logo/logo-brand.png',
    nindya: './static/img/logo/nindya.png'
  },
  server: {
    development: 'http://localhost:9600',
    stagging: 'https://api.teknologireadymix.com/rbs/monitoring',
    demo: 'https://app-demo.rbsmixsolution.com/api/monitoring',
    production: 'https://api.rbsmixsolution.com/monitoring',
  },
  sso: {
    stagging: 'https://api.rbsmixsolution.com/monitoring',
    development: 'https://api.rbsmixsolution.com/monitoring',
    production: 'https://api.rbsmixsolution.com/monitoring',
    demo: 'https://api.rbsmixsolution.com/monitoring'
  },
  download: {
    android: 'https://play.google.com/store/',
    ios: 'https://www.apple.com/id/app-store/'
  },
  options: {
    allowRegister: false,
    forgetPassword: false,
    autofill: false,
    myAction: false,
    asideRight: false,
    sso: false,
    bypass: {
      login: true,
      screen: true
    }
  }
}

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app



// WEBPACK FOOTER //
// ./src/config.js